import React, {useEffect} from 'react';
import {usePagination, useRowSelect, useSortBy, useTable} from 'react-table';
import {useTranslation} from "react-i18next";
import {Col, CustomInput, Input, Row, Table} from 'reactstrap';
import Aux from '../../hoc/Auxiliary';

const CheckedTable = ({columns,
                          data,
                          doXLSExport,
                          children,
                          hideExport,
                          doXLSDetailExport,
                          checked, onSort,
                          setSortByCallback,
                          initialStateField, initialStateDirection }) => {
    const {
        getTableProps,
        getTableBodyProps,
        getSortedItems,
        headerGroups,
        prepareRow,
        setSorterCallback,
        sortTableDirection,
        setSortBy,
        sortTableField,
        page,
        rows,
        sortBy,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data,
            rows,
            sortBy: [{id: initialStateField, desc: initialStateDirection==='DESC'?true:false}],
        },
        useSortBy,
        usePagination,
        useRowSelect,
    );

    const { t, i18n } = useTranslation();
    const generateSortingIndicator = (column) => {
        return column.isSorted ? (
            column.isSortedDesc ? (
                <i className="fa fa-angle-down"></i>
            ) : (
                <i className="fa fa-angle-up"></i>
            )
        ) : (
            ""
        );
    };

    useEffect(() => {
        if (onSort) {
            onSort(sortBy);
        }
    }, [sortBy]);


    useEffect(() => {
        if (setSortByCallback && setSortByCallback.length) {
            setSortBy(setSortByCallback)
        }
    }, [setSortByCallback]);

    const onChangeInSelect = (event) => {
        setPageSize(Number(event.target.value));
    };

    const onChangeInInput = (event) => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0;
        gotoPage(page);
    };

    return (
        <Aux>
            <div className="d-flex flex-wrap justify-content-between mt-3 payment-toolbar">
                {!hideExport && <div className="btn-export-xls">
                    <img
                        className="specialarrow"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAVCAYAAAC6wOViAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAETSURBVHgB7ZYxjoJAFIbfoPRuSWg4woRAQrd6AvcKewNvIJ5g9wp7hD2B2tFA8AZ2tPQE8H8JNhMxg77Exi+BeUzmn28oGEbRHeI41l3X7VEuSIZDnucr596Itm3XgkLq+z7gdm45vsYCNvQ8J2spVliXZflHQjj0At7St1SEeRRFG3wSa9d1v7MsO08JP5p1ENqiXTZNs0+SJLANQpgi+zNkP2kCLN0NdWArHoS8WN44SuxW/zQBpyiKXwRTW7EpxA9hhd2qpilSvkG8sxFLCJnZtaiq6uh5HimllnhcYMIv1DyhxlX7vv8hIWSU2RGG4RaydCzwrJCZmR3GG4sLb0rHxFLCUakplhRaobUWO65cuQA3T9LjPVThWAAAAABJRU5ErkJggg=="
                    />
                    <div className={doXLSDetailExport ? "dropdown" : "button"}>
                        <button
                            disabled={checked && checked.length === 0}
                            className={`btn btn-secondary ${doXLSDetailExport ? "dropdown-toggle" : ""}`}
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle={doXLSDetailExport ? "dropdown" : ""}
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={doXLSDetailExport ? () => {
                            } : () => {
								doXLSExport('xls');
							}}
                        >
                            {t("docs.invoices.table.xls_download")}
                            &nbsp;&nbsp;
                            <i className="far fa-file-spreadsheet"></i>
                        </button>
                        {doXLSDetailExport ? (
                            <>
                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    <button
                                        disabled={checked && checked.length === 0}
                                        className="dropdown-item"
                                        onClick={() => doXLSExport('xls')}
                                    >
                                        {t("docs.invoices.table.xls_summary")}
                                    </button>
                                    <button
                                        disabled={checked && checked.length === 0}
                                        className="dropdown-item"
                                        onClick={() => doXLSDetailExport('xls')}
                                    >
                                        {t("docs.invoices.table.xls_detail")}
                                    </button>
                                    <button
                                        disabled={checked && checked.length === 0}
                                        className="dropdown-item"
                                        onClick={() => doXLSExport('csv')}
                                    >
                                        {t("docs.invoices.table.csv_summary")}
                                    </button>
                                    <button
                                        disabled={checked && checked.length === 0}
                                        className="dropdown-item"
                                        onClick={() => doXLSDetailExport('csv')}
                                    >
                                        {t("docs.invoices.table.csv_detail")}
                                    </button>
                                </div>
                            </>
                        ) : null}
                    </div>
                </div> }
                {children && children}
            </div>
            <div className="table-wrapper table-wrapper--nopadd">
                <Table
                    hover
                    {...getTableProps()}
                    className="datatable datatable--communications"
                >
                    <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    <div {...column.getSortByToggleProps({title: t(`docs.togglesortby`)+' '+column.render("Header")})}>
                                        {column.render("Header")}
                                        {generateSortingIndicator(column)}
                                    </div>
                                    {/*<Filter column={column} /> */}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                        prepareRow(row);
                        return (
                            <Aux key={row.getRowProps().key}>
                                <tr>
                                    {row.cells.map((cell) => {
                                        return (
                                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        );
                                    })}
                                </tr>
                            </Aux>
                        );
                    })}
                    </tbody>
                </Table>
            </div>
            <div className="datatable__actions">
                <div className="datatable__actions__extras">
                    <Row className="flex--align-center">
                        <Col xs={6}>Page{' '} <strong>{pageIndex + 1} {t(`docs.pagination.of`)} {pageOptions.length === 0 ? pageOptions.length+1 : pageOptions.length}</strong></Col>
                        <Col xs={6} className="a-right">
                            <CustomInput
                                type="select"
                                value={pageSize}
                                id="row-range-select"
                                onChange={onChangeInSelect}
                            >

                                {[10, 20, 30, 40, 50].map((pageSize) => (
                                    <option key={pageSize} value={pageSize}>
                                        {t('misc.sorter.show')} {pageSize}
                                    </option>
                                ))}
                            </CustomInput>

                        </Col>
                    </Row>
                </div>
                <div className="datatable__actions__base flex flex--justify-center">
                    <button className="btn btn--table" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        <i className="fas fa-angle-double-left"></i>
                    </button>
                    <button className="btn btn--table" onClick={previousPage} disabled={!canPreviousPage}>
                        <i className="fas fa-angle-left"></i>
                    </button>
                    <div>
                        <Input
                            type='number'
                            className='input-current-page'
                            min={1}
                            style={{width: 70}}
                            max={pageOptions.length}
                            value={pageIndex + 1}
                            onChange={onChangeInInput}
                        />

                    </div>
                    <button className="btn btn--table" onClick={nextPage} disabled={!canNextPage}>
                        <i className="fas fa-angle-right"></i>
                    </button>
                    <button className="btn btn--table" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        <i className="fas fa-angle-double-right"></i>
                    </button>
                </div>
            </div>
        </Aux>
    );
};

export default CheckedTable;
